import React, { useState } from "react";
import { PageShell, SectionLabel, SlideCorner } from "@/components/Layout";
import { Play, ArrowRight } from "lucide-react";

const WRITTEN = [
  { slug: "the-quiet-economy", title: "The quiet economy of Indian indie music", excerpt: "What it really costs to put out a record in this country — and who is paying for it.", date: "Feb 2026", read: "8 min", img: "https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f" },
  { slug: "studios-after-dark", title: "Studios after dark: a night in Andheri", excerpt: "Five practitioners. One block. Three a.m.", date: "Jan 2026", read: "11 min", img: "https://images.unsplash.com/photo-1485178575877-1a13bf489dfe" },
  { slug: "phulkari-neon", title: "Phulkari, but make it neon", excerpt: "How Meher Kaur is rewriting a Punjabi tradition for a generation raised on screens.", date: "Jan 2026", read: "6 min", img: "https://images.unsplash.com/photo-1547891654-e66ed7ebb968" },
];

const PODCAST = [
  { slug: "ep-01", title: "Episode 01 · The cost of being an artist in 2026", guest: "Karan Joshi, comedian", duration: "52 min", date: "Feb 2026", img: "https://images.unsplash.com/photo-1539571696357-5a69c17a67c6" },
  { slug: "ep-02", title: "Episode 02 · You don't need permission, you need a calendar", guest: "Ira Rao, creative director", duration: "61 min", date: "Jan 2026", img: "https://images.pexels.com/photos/20697386/pexels-photo-20697386.jpeg" },
  { slug: "ep-03", title: "Episode 03 · Touring India without losing your mind", guest: "Rahul D'Souza", duration: "48 min", date: "Jan 2026", img: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e" },
];

export default function Editorial() {
  const [format, setFormat] = useState("written");
  return (
    <PageShell>
      <section className="relative grid-bg border-b border-border">
        <SlideCorner right="THE EDIT" />
        <div className="max-w-[1600px] mx-auto px-5 md:px-10 pt-20 pb-12">
          <SectionLabel>The Edit</SectionLabel>
          <h1 className="font-display text-5xl md:text-7xl lg:text-[7rem] font-bold leading-[0.9] tracking-tighter">
            Written. Visual. <br /> <span className="hl-coral">Opinionated.</span>
          </h1>
          <p className="mt-8 max-w-2xl text-white/80 text-base md:text-lg leading-relaxed">
            The Edit is anArtizen's editorial vertical — commentary on Indian creative culture, conversations with practitioners, and well-produced longform. <span className="text-white/55">Not a news aggregator.</span>
          </p>
        </div>
      </section>

      <section className="border-b border-border sticky top-14 z-30 bg-background/95 backdrop-blur">
        <div className="max-w-[1600px] mx-auto px-5 md:px-10 py-5 flex flex-wrap items-center gap-3">
          <p className="meta-mono mr-4">— FORMAT</p>
          {[
            { k: "written", l: "Written" },
            { k: "podcast", l: "No Pressure · Podcast" },
          ].map((opt) => (
            <button
              key={opt.k}
              data-testid={`edit-toggle-${opt.k}`}
              onClick={() => setFormat(opt.k)}
              className={`btn-pill ${format === opt.k ? "btn-coral" : ""}`}
            >
              {opt.l}
            </button>
          ))}
        </div>
      </section>

      <section className="border-b border-border">
        <div className="max-w-[1600px] mx-auto px-5 md:px-10 py-16">
          {format === "written" ? (
            <div className="grid md:grid-cols-3 gap-px bg-border" data-testid="edit-list-written">
              {WRITTEN.map((w) => (
                <article key={w.slug} className="bg-background group cursor-pointer">
                  <div className="aspect-[5/4] overflow-hidden">
                    <img src={w.img} alt="" className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition" />
                  </div>
                  <div className="p-6">
                    <p className="meta-mono !text-primary">— {w.date} · {w.read}</p>
                    <h3 className="font-display text-2xl md:text-3xl font-bold mt-3 leading-tight">{w.title}</h3>
                    <p className="mt-3 text-white/75 text-sm leading-relaxed">{w.excerpt}</p>
                    <p className="meta-mono mt-5 flex items-center gap-2">READ <ArrowRight size={12} /></p>
                  </div>
                </article>
              ))}
            </div>
          ) : (
            <div className="grid gap-px bg-border" data-testid="edit-list-podcast">
              {PODCAST.map((p) => (
                <article key={p.slug} className="bg-background p-6 md:p-8 flex flex-col md:flex-row gap-6 items-start">
                  <div className="w-full md:w-48 aspect-square overflow-hidden shrink-0">
                    <img src={p.img} alt="" className="w-full h-full object-cover grayscale" />
                  </div>
                  <div className="flex-1">
                    <p className="meta-mono !text-secondary">— {p.date} · {p.duration}</p>
                    <h3 className="font-display text-2xl md:text-3xl font-bold mt-3 leading-tight">{p.title}</h3>
                    <p className="mt-2 text-white/70 text-sm">Guest: {p.guest}</p>
                    <button className="btn-pill mt-5 btn-coral"><Play size={13} /> Play episode</button>
                  </div>
                </article>
              ))}
            </div>
          )}
        </div>
      </section>
    </PageShell>
  );
}
